export default __webpack_public_path__ + "static/media/getapp.70a2fcf9.svg";